import {
  FETCH_NEXT_AVAILABLE_DELIVERY_SLOT_ERROR,
  FETCH_NEXT_AVAILABLE_DELIVERY_SLOT_REQUEST,
  FETCH_NEXT_AVAILABLE_DELIVERY_SLOT_SUCCESS,
} from '../actions/nextAvailableDeliverySlot';

export const initialState = {
  slot: null,
  error: null,
};

export default function nextAvailableDeliverySlot(state = initialState, action) {
  switch (action.type) {
    case FETCH_NEXT_AVAILABLE_DELIVERY_SLOT_REQUEST: {
      return state;
    }
    case FETCH_NEXT_AVAILABLE_DELIVERY_SLOT_SUCCESS: {
      const { data } = action;

      return {
        ...state,
        slot: data,
      };
    }
    case FETCH_NEXT_AVAILABLE_DELIVERY_SLOT_ERROR: {
      return {
        ...initialState,
        error: action.error,
      };
    }
    default:
      return state;
  }
}
